module.exports = __webpack_public_path__ + "img/process.svg";